import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 6rem 2rem;
  gap: 2rem;
`;

const Heading = styled.h2`
  font-size: min(3rem, 10vw);
  font-weight: bold;
  color: #333;
  margin: 0 0 1.25rem 0;
  letter-spacing: -0.02em;
  line-height: 1.15;
  max-width: 680px;
`;

const SignUpButton = styled.button`
  align-self: center;
`;

const TrustNote = styled.p`
  font-size: 0.78rem;
  color: #7b746c;
  margin: 1rem 0 0 0;
  letter-spacing: 0.01em;
`;

function JoinSection({ onAuthOpen }) {
  return (
    <Container>
      <Heading>Build with Us Early</Heading>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <SignUpButton onClick={onAuthOpen}>Get Free Access</SignUpButton>
        <TrustNote>
          Free during beta&nbsp; · &nbsp;No credit card required&nbsp; ·
          &nbsp;Cancel anytime
        </TrustNote>
      </div>
    </Container>
  );
}

export default JoinSection;
